import dayjs from 'dayjs';
import { IProduct } from 'app/shared/model/product.model';

export interface IDailyProductUsage {
  id?: number;
  price?: number;
  from?: dayjs.Dayjs | null;
  util?: dayjs.Dayjs | null;
  dailyUsage?: number | null;
  product?: IProduct | null;
}

export const defaultValue: Readonly<IDailyProductUsage> = {};
